// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DebounceController from "./debounce_controller"
application.register("debounce", DebounceController)

import PopupController from "./popup_controller"
application.register("popup", PopupController)

import SessionLoaderController from "./session_loader_controller"
application.register("session-loader", SessionLoaderController)

import AutoplayVideoController from "./autoplay_video_controller"
application.register("autoplay-video", AutoplayVideoController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import AvatarUploadController from "./avatar_upload_controller"
application.register("avatar-upload", AvatarUploadController)

import BackNavController from "./back_nav_controller"
application.register("back-nav", BackNavController)

import BookmarkManagerController from "./bookmark_manager_controller"
application.register("bookmark-manager", BookmarkManagerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import StickyVideoController from "./sticky_video_controller"
application.register("sticky-video", StickyVideoController)

import TableOfContentsController from "./table_of_contents_controller"
application.register("table-of-contents", TableOfContentsController)

import TerminalTitleController from "./terminal_title_controller"
application.register("terminal-title", TerminalTitleController)

import VideoSectionsController from "./video_sections_controller"
application.register("video-sections", VideoSectionsController)

import WadTrackingController from "./wad_tracking_controller"
application.register("wad-tracking", WadTrackingController)

import CongressBroadcastRecordingsController from "./congress_broadcast/recordings_controller"
application.register("congress-broadcast--recordings", CongressBroadcastRecordingsController)
